import { preaddStyles } from "./styles";
import InputMask from "react-input-mask";
import { BLUE_EIGHT } from "../../theme";
import ReactDropzone from "react-dropzone";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/styles";
import React, { useEffect, useState } from "react";
import { PrimaryButton } from "../../styles/colors";
import { FormSelect } from "../form";
import { TextFieldComponent } from "../form/textFeild";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { NATIONALITY, ROLES } from "../../util/constants";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  TextField,
  Grid,
} from "@material-ui/core";
import { getSchoolById } from "../../api/schools";
import { useSelector } from "react-redux";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import "./style.css";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),

      "& .MuiOutlinedInput-root": {
        borderRadius: 10,
      },
    },
  },
}));

export const AddUserForm = ({
  firstName,
  lastName,
  role,
  schoolId,
  phone,
  password,
  email,
  errors,
  handleChange,
  handleChangePhone,
  handleChangeOtherPhone,
  emirateId,
  passport,
  birth,
  gender,
  nationality,
  area,
  region,
  address,
  otherPhone,
  employeId,
  designation,
  user,
  SCHOOL_IDS,
  isEditedItem,
  handleFile = () => { },
}) => {
  const classes = preaddStyles();
  const { t } = useTranslation();
  const { token } = useSelector((state) => state.user);
  const GENDER = [
    {
      value: "male",
      label: t("text_male"),
    },
    {
      value: "female",
      label: t("text_female"),
    },
    {
      value: "other",
      label: t("text_other"),
    },
  ];

  const [file, setFile] = useState(null);
  const [radioValue, setRadioValue] = useState("emirateId");
  const [schoolName, setSchoolName] = useState("");
  const inputClasses = useStyles();

  const handleChangeForRadioButton = (event) => {
    setRadioValue(event.target.value);
  };

  const uploadFile = (acceptedFiles) => {
    if (acceptedFiles.length > 0) setFile(acceptedFiles[0]);
  };

  useEffect(() => {
    handleFile(file);
  }, [file]);

  const fetchSchool = async () => {
    try {
      const response = await getSchoolById(schoolId, token);
      if (!response.status) {
        console.error(response?.message);
        return;
      }
      setSchoolName(response?.school?.name);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if(isEditedItem && user?.role === 'superadmin') {
      fetchSchool();
    }
    
  }, [schoolId]);

  return (
    <div className={classes.addSchoolForm}>
      <Typography
        variant="h3"
        style={{ color: BLUE_EIGHT, marginBottom: 10, marginLeft: 10 }}
      >
        Personal Details
      </Typography>
      <Grid container className={classes.gridRoot} spacing={2}>
        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            required={true}
            errorMessage={
              errors.indexOf("firstName") > -1 === true &&
              t("text_first_name") + " " + t("text_is_required")
            }
            error={errors.indexOf("firstName") > -1}
            value={firstName}
            onChange={handleChange}
            label={t("text_first_name")}
            name={"firstName"}
          />
        </Grid>

        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            required={true}
            errorMessage={
              errors.indexOf("lastName") > -1 === true &&
              t("text_last_name") + " " + t("text_is_required")
            }
            error={errors.indexOf("lastName") > -1}
            value={lastName}
            onChange={handleChange}
            label={t("text_last_name")}
            name={"lastName"}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            required={true}
            error={errors.indexOf("birth") > -1}
            errorMessage={
              errors.indexOf("birth") > -1 === true &&
              t("text_date_of_birth") + " " + t("text_is_required")
            }
            type="date"
            customLabel={true}
            value={birth}
            onChange={handleChange}
            label={t("text_date_of_birth")}
            name={"birth"}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <FormSelect
            required={true}
            errorMessage={
              errors.indexOf("gender") > -1 === true &&
              t("text_gender") + " " + t("text_is_required")
            }
            error={errors.indexOf("gender") > -1}
            label={t("text_gender")}
            name={"gender"}
            value={gender}
            list={GENDER}
            onChange={handleChange}
          />
        </Grid>
        <Grid item sm={6} xs={12} className="custom-label-wrapper">
          <FormControl
            className={classes.radioButtonLabel}
            component="fieldset"
          >
            <RadioGroup
              style={{ flexDirection: "row" }}
              value={radioValue}
              onChange={handleChangeForRadioButton}
            >
              <FormControlLabel
                value="emirateId"
                control={<Radio />}
                label={t("text_emirates_id")}
              />
              <FormControlLabel
                value="passport"
                control={<Radio />}
                label={t("text_passport")}
              />
            </RadioGroup>
          </FormControl>

          {radioValue === "emirateId" ? (
            <FormControl
              className={inputClasses.root}
              variant="outlined"
              fullWidth
            >
              <InputMask
                mask="999-9999-9999999-9"
                value={emirateId}
                onChange={handleChange("emirateId")}
              >
                {(inputProps) => (
                  <TextField
                    {...inputProps}
                    color={BLUE_EIGHT}
                    type="text"
                    name={"emirateId"}
                    value={emirateId}
                    id="text-input"
                    size="small"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              </InputMask>
            </FormControl>
          ) : (
            <TextFieldComponent
              value={passport}
              onChange={handleChange}
              name={"passport"}
            />
          )}
        </Grid>

        <Grid item sm={6} xs={12}>
          <FormSelect
            required={true}
            errorMessage={
              errors.indexOf("nationality") > -1 === true &&
              t("text_nationality") + " " + t("text_is_required")
            }
            error={errors.indexOf("nationality") > -1}
            onChange={handleChange}
            label={t("text_nationality")}
            name={"nationality"}
            value={nationality}
            list={NATIONALITY}
          />
        </Grid>
      </Grid>
      <hr />

      <Typography
        variant="h3"
        style={{ color: BLUE_EIGHT, marginBottom: 10, marginLeft: 10 }}
      >
        {t("text_address_and_contact_detail")}
      </Typography>
      <Grid container className={classes.gridRoot} spacing={2}>
        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            required={true}
            errorMessage={
              errors.indexOf("area") > -1 === true &&
              t("text_area") + " " + t("text_is_required")
            }
            error={errors.indexOf("area") > -1}
            onChange={handleChange}
            label={t("text_area")}
            value={area}
            name={"area"}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            required={true}
            errorMessage={
              errors.indexOf("region") > -1 === true &&
              t("text_region") + " " + t("text_is_required")
            }
            error={errors.indexOf("region") > -1}
            onChange={handleChange}
            label={t("text_region")}
            name={"region"}
            value={region}
          />
        </Grid>
        <Grid item xs={12}>
          <TextFieldComponent
            required={true}
            errorMessage={
              errors.indexOf("address") > -1 === true &&
              t("text_address") + " " + t("text_is_required")
            }
            error={errors.indexOf("address") > -1}
            onChange={handleChange}
            label={t("text_address")}
            name={"address"}
            value={address}
          />
        </Grid>
        <Grid item sm={6} xs={12} style={{ paddingLeft: "15px" }}>
          {!isEditedItem && (
            <ReactPhoneInput
              containerClass="my-phone-input"
              inputStyle={{
                marginTop: "6px",
                width: "95%",
                borderRadius: "10px",
              }}
              value={phone}
              name={"phone"}
              inputProps={{
                name: "phone",
                required: true,
              }}
              onChange={handleChangePhone}
              country={"ae"}
              specialLabel={`${t("text_phone_number")} *`}
              defaultErrorMessage={
                t("text_phone_number") + " " + t("text_is_required")
              }
              placeholder={"XXXXXXXXXX"}
            />
          )}
        </Grid>
        <Grid item sm={isEditedItem ? 12 : 6} xs={12}>
          <ReactPhoneInput
            containerClass="my-phone-input"
            inputStyle={{
              marginTop: "6px",
              width: "95%",
              borderRadius: "10px",
            }}
            value={otherPhone}
            name={"otherPhone"}
            onChange={handleChangeOtherPhone}
            country={"ae"}
            specialLabel={t("text_other_number")}
            placeholder={"XXXXXXXXXX"}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          {!isEditedItem && (
            <TextFieldComponent
              required={true}
              errorMessage={
                errors.indexOf("email") > -1 === true &&
                t("text_email") + " " + t("text_is_required")
              }
              error={errors.indexOf("email") > -1}
              onChange={handleChange}
              label={t("text_email")}
              value={email}
              type={"Email"}
              name={"email"}
            />
          )}
        </Grid>
        <Grid item sm={6} xs={12}>
          {!isEditedItem && (
            <TextFieldComponent
              required={true}
              errorMessage={
                errors.indexOf("password") > -1 === true &&
                t("text_password") + " " + t("text_is_required")
              }
              error={errors.indexOf("password") > -1}
              value={password}
              onChange={handleChange}
              label={t("text_password")}
              name={"password"}
              type={"password"}
            />
          )}
        </Grid>
      </Grid>
      <hr />

      <Typography
        variant="h3"
        style={{ color: BLUE_EIGHT, marginBottom: 10, marginLeft: 10 }}
      >
        {t("text_official_details")}
      </Typography>
      <Grid container className={classes.gridRoot} spacing={2}>
        {user?.role === "manager" && (
          <Grid item sm={6} xs={12}>
            <TextFieldComponent
              disabled={true}
              onChange={handleChange}
              label={t("text_school_name")}
              value={SCHOOL_IDS[0].label}
              name={"schoolId"}
            />
          </Grid>
        )}

        {user?.role === "superadmin" && (
          <Grid item sm={6} xs={12}>
            {isEditedItem ? (
              <TextFieldComponent
                disabled={true}
                onChange={handleChange}
                label={t("text_school_name")}
                value={schoolName}
                name={"schoolId"}
              />
            ) : (
              <FormSelect
                required={true}
                onChange={handleChange}
                label={t("text_school_name")}
                name={"schoolId"}
                value={schoolId}
                list={SCHOOL_IDS}
              />
            )}
          </Grid>
        )}

        {/* {(user.role === "superadmin") && ( */}
        <Grid item sm={6} xs={12}>
          <FormSelect
            required={true}
            errorMessage={
              errors.indexOf("role") > -1 === true &&
              t("text_role") + " " + t("text_is_required")
            }
            error={errors.indexOf("role") > -1}
            onChange={handleChange}
            label={t("text_role")}
            name={"role"}
            value={role}
            list={ROLES}
          />
        </Grid>
        {/* )} */}

        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            onChange={handleChange}
            label={t("text_employee_id")}
            value={employeId}
            name={"employeId"}
            type="number"
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            required={true}
            errorMessage={
              errors.indexOf("designation") > -1 === true &&
              t("text_designation") + " " + t("text_is_required")
            }
            error={errors.indexOf("designation") > -1}
            onChange={handleChange}
            label={t("text_designation")}
            value={designation}
            name={"designation"}
          />
        </Grid>
      </Grid>
      <hr />

      <div style={{ padding: "20px 0px" }}>
        <Typography variant="h5" className={"add-student-form"}>
          {t("text_add_scanned_image_of_User_uae_id_card")}
        </Typography>
        <ReactDropzone
          onDrop={uploadFile}
          multiple={false}
          accept={"image/jpeg,image/png"}
        >
          {({ getRootProps, getInputProps }) => (
            <div
              style={{
                width: "100%",
                border: "1px dashed rgb(240,242,248)",
                padding: 7,
                borderRadius: 5,
              }}
              {...getRootProps()}
            >
              <input {...getInputProps()} />
              <div
                style={{
                  width: "100%",
                  padding: 15,
                  borderRadius: 5,
                  backgroundColor: "rgb(240,242,248)",
                  color: "black",
                  fontSize: 14,
                  fontWeight: "400",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <CloudUploadIcon
                  style={{ color: "lightgray", marginRight: 10 }}
                />
                {file && `${file.name}      `}
                <Typography variant="body2">
                  {t("text_drag_&_drop")}
                  <span style={{ color: "gray", paddingLeft: 5 }}>
                    {t("text_your_files_or")}
                  </span>
                  <span
                    style={{
                      color: PrimaryButton,
                      cursor: "pointer",
                      paddingLeft: 5,
                      textDecoration: "underline",
                    }}
                  >
                    {t("text_browse")}
                  </span>
                </Typography>
              </div>
            </div>
          )}
        </ReactDropzone>
      </div>
    </div>
  );
};
